import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/collections/license.invoiceFollowUp.upsert.mutation.gql"
import type {
  InvoiceFollowUpUpsertMutation,
  InvoiceFollowUpUpsertMutationVariables,
} from "@/v2-backoffice-client/license/collections/__types__/license.invoiceFollowUp.upsert.mutation"

type Options = MutationHookOptions<
  InvoiceFollowUpUpsertMutation,
  InvoiceFollowUpUpsertMutationVariables
>

export function useInvoiceFollowUpUpsertMutation(options?: Options) {
  return useMutation<
    InvoiceFollowUpUpsertMutation,
    InvoiceFollowUpUpsertMutationVariables
  >(mutation, options)
}
